import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '@/App';
import { MapPin } from 'lucide-react';
import { Button } from '@/components/ui/button';

const cities = [
  {
    id: 'cape_town',
    name: 'Cape Town',
    lat: -33.9249,
    lng: 18.4241,
    image: 'https://images.unsplash.com/photo-1679128991873-c8ae350fe8b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxjYXBlJTIwdG93biUyMGNpdHklMjBza3lsaW5lJTIwdGFibGUlMjBtb3VudGFpbnxlbnwwfHx8fDE3NjcwODY2MjJ8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'johannesburg',
    name: 'Johannesburg',
    lat: -26.2041,
    lng: 28.0473,
    image: 'https://images.unsplash.com/photo-1604348489791-f95132c5d8c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxqb2hhbm5lc2J1cmclMjBjaXR5JTIwc2t5bGluZXxlbnwwfHx8fDE3NjcwODY2MjN8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'pretoria',
    name: 'Pretoria',
    lat: -25.7479,
    lng: 28.2293,
    image:
      'https://images.unsplash.com/photo-1640579986765-84278de3bcce?auto=format&fit=crop&w=1200&q=85',
  },
  {
    id: 'durban',
    name: 'Durban',
    lat: -29.8587,
    lng: 31.0218,
    image:
      'https://images.unsplash.com/photo-1656776832783-c1671a7ad521?auto=format&fit=crop&w=1200&q=85',
  },
  {
    id: 'gqeberha',
    name: 'Gqeberha (Port Elizabeth)',
    lat: -33.9608,
    lng: 25.6022,
    image:
      'https://images.unsplash.com/photo-1641289627582-7dae364d2da7?auto=format&fit=crop&w=1200&q=85',
  },
  {
    id: 'bloemfontein',
    name: 'Bloemfontein',
    lat: -29.1211,
    lng: 26.214,
    image:
      'https://images.unsplash.com/photo-1755020172774-49c75ce8e9ac?auto=format&fit=crop&w=1200&q=85',
  },
];

export default function CitySelection() {
  const navigate = useNavigate();
  const { selectCity } = useContext(AuthContext);

  const handleCitySelect = (city) => {
    selectCity(city);
    navigate('/search');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-secondary/30 via-background to-primary/5 p-4 md:p-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 pt-8">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold text-primary mb-4 tracking-tight">
            Vexi
          </h1>
          <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto">
            Community-driven price sharing across South Africa
          </p>
        </div>

        <div className="mb-8">
          <h2 className="text-lg font-heading font-medium text-foreground mb-4 flex items-center justify-center gap-2">
            <MapPin className="w-5 h-5 text-accent" />
            Select Your City
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-6xl mx-auto">
          {cities.map((city) => (
            <button
              key={city.id}
              data-testid={`city-card-${city.id}`}
              onClick={() => handleCitySelect(city)}
              className="relative overflow-hidden rounded-3xl aspect-[4/3] group cursor-pointer hover-lift"
            >
              <img
                src={city.image}
                alt={city.name}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 className="text-white text-xl font-heading font-bold mb-1">
                  {city.name}
                </h3>
                <p className="text-white/80 text-sm">Tap to explore</p>
              </div>
            </button>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Button
            data-testid="auth-button-city-page"
            onClick={() => navigate('/auth')}
            variant="ghost"
            className="text-muted-foreground hover:text-foreground"
          >
            Already have an account? Sign in
          </Button>
        </div>
      </div>
    </div>
  );
}